export const FilterTypes = { VARCHAR2: 'text', DATE: 'date', NUMBER: 'number' }
